import { render, staticRenderFns } from "./PreviewInfo.vue?vue&type=template&id=0b4a191b&scoped=true"
import script from "./PreviewInfo.vue?vue&type=script&lang=js"
export * from "./PreviewInfo.vue?vue&type=script&lang=js"
import style0 from "./PreviewInfo.vue?vue&type=style&index=0&id=0b4a191b&prod&lang=scss"
import style1 from "./PreviewInfo.vue?vue&type=style&index=1&id=0b4a191b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4a191b",
  null
  
)

export default component.exports